import React, { useContext } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';

import { Checkbox } from 'semantic-ui-react';

import { SatCoreRegister } from '../../SatCoreRegistry';

import ReportCourseService from '../../services/reports/ReportCourseService';
import ReportTableService from '../../services/reports/ReportTableService';

const ReportCustomCoursesToggler = observer((props) => {
  const { t } = props;

  const { reportIdentityManager, reportCourseManager } = useContext(MobXProviderContext);

  const { selectedReportCourseName } = reportCourseManager;

  const handleToggleCustomCourses = (_event, data) => {
    const shouldHideCustomCourses = data.checked;

    reportCourseManager.setShouldHideCustomCourses(shouldHideCustomCourses);

    const isCustomCourse = ReportCourseService.isReportCustomCourse(selectedReportCourseName || '');

    if (shouldHideCustomCourses && isCustomCourse) {
      // user has a custom course selected, but custom courses have been toggled off.
      // for this reason, we need to unselect the custom course since it is now hidden.
      reportCourseManager.setSelectedReportCourseInfo(null, null);
    }
    ReportTableService.forceRerenderReportTable();
  };

  const renderCustomCourses = () => {
    const { reportInfoClassNames } = reportIdentityManager;
    const { shouldHideCustomCourses } = reportCourseManager;
    return (
      <div className={`report-custom-courses-toggler ${reportInfoClassNames}`}>
        <div className='toggle-hide-or-show-wrapper'>
          <Checkbox
            className='hide-or-show-toggler hide-or-show-toggler-directly-on-background'
            defaultChecked={shouldHideCustomCourses}
            label={t(shouldHideCustomCourses ? 'hideCustomCoursesTrueLabel' : 'hideCustomCoursesFalseLabel')}
            onChange={handleToggleCustomCourses}
            toggle />
        </div>
      </div>
    );
  };
  return renderCustomCourses();
});
export default ReportCustomCoursesToggler;

SatCoreRegister('ReportCustomCoursesToggler', ReportCustomCoursesToggler);
